import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";

export const getAllProjectRequests = createAsyncThunk(
  'projectApprovedTask/getAllProjectRequests',
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get("/projectApprovedTask/getallprojects");
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const createApprovedTask = createAsyncThunk(
  'projectApprovedTask/createApprovedTask',
  async (taskData, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/projectApprovedTask/approved-task/", taskData);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getApprovedTasksByPerson = createAsyncThunk(
  'projectApprovedTask/getApprovedTasksByPerson',
  async (assignedPerson, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get(`/projectApprovedTask/approved-task/${assignedPerson}`);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateApprovedTask = createAsyncThunk(
  'projectApprovedTask/updateApprovedTask',
  async ({ id, updatedData }, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.put(`/projectApprovedTask/${id}`, updatedData);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteApprovedTask = createAsyncThunk(
  'projectApprovedTask/deleteApprovedTask',
  async (id, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`/projectApprovedTask/${id}`);
      return id;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const projectApprovedTaskSlice = createSlice({
  name: 'projectApprovedTask',
  initialState: {
    tasks: [],
    approvedTasksState:[],
    allProjects: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder

    .addCase(createApprovedTask.pending, (state) => {
        state.loading = true;
      })
      .addCase(createApprovedTask.fulfilled, (state, action) => {
        state.loading = false;
        state.tasks.push(action.payload);
      })
      .addCase(createApprovedTask.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getApprovedTasksByPerson.pending, (state) => {
        state.loading = true;
      })
      .addCase(getApprovedTasksByPerson.fulfilled, (state, action) => {
        state.loading = false;
        state.approvedTasksState = action.payload;
      })
      .addCase(getApprovedTasksByPerson.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updateApprovedTask.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateApprovedTask.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.tasks.findIndex(task => task._id === action.payload._id);
        if (index !== -1) {
          state.tasks[index] = action.payload;
        }
      })
      .addCase(updateApprovedTask.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deleteApprovedTask.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteApprovedTask.fulfilled, (state, action) => {
        state.loading = false;
        state.tasks = state.tasks.filter(task => task._id !== action.payload);
      })
      .addCase(deleteApprovedTask.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getAllProjectRequests.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllProjectRequests.fulfilled, (state, action) => {
        state.loading = false;
        state.allProjects = action.payload;
      })
      .addCase(getAllProjectRequests.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });


  },
});

export const { clearError } = projectApprovedTaskSlice.actions;
export default projectApprovedTaskSlice.reducer;
